<div #scrollContainer class="overflow-y-auto h-screen">
  <app-header [scrolled]="scrolled"></app-header>
  <section
    #heroSection
    class="transition-all duration-700 ease-out"
    style="
      background: linear-gradient(
        180deg,
        #5c9dfe 0%,
        #5c9dfe 39.94%,
        #8bc9f9 113.79%
      );
    ">
    <div
      #scrollArea
      class="pt-20 px-2"
      style="
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.28) 0%,
          rgba(0, 0, 0, 0) 100%
        );
      ">
      <div class="w-full hidden lg:block">
        <div
          class="text-white"
          class="max-w-7xl px-8 flex items-center gap-x-3 px-6 py-4 mx-auto">
          <img
            src="assets/images/home.png"
            loading="lazy"
            class="filter invert-0" />
          <img
            src="assets/images/arrow.png"
            loading="lazy"
            class="filter invert-0" />
          <span class="text-white text-sm sm:text-base">Products</span>
          <img
            src="assets/images/arrow.png"
            loading="lazy"
            class="filter invert-0" />
          <span class="text-white text-sm sm:text-base">ORBIT</span>
        </div>
      </div>

      <div class="mx-auto container relative pb-20">
        <!-- z-5 block -->
        <div
          #topContent
          class="z-45 relative will-change-transform will-change-opacity transition-all duration-1000 ease-in-out">
          <div class="cursor-pointer" #orbitLogo>
            <img
              src="assets/img/logo/orbit-logo.webp"
              alt="Volmint Orbit Logo"
              loading="lazy"
              class="h-auto mx-auto w-16 sm:w-20 md:w-24 lg:w-28 xl:w-32"
              width="50"
              height="50" />
          </div>
          <h1
            class="w-full max-w-5xl mx-auto text-center font-['Plus_Jakarta_Sans'] text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-snug sm:leading-normal md:leading-[66px] tracking-tight md:font-medium">
            <span class="text-[#8cc1fd]">ORBIT</span
            ><span class="text-white">
              - Redefining Office Management with Ease & Efficiency</span
            >
          </h1>
          <p
            class="w-full max-w-5xl mx-auto text-center text-white font-sans text-sm sm:text-base leading-6 mt-10">
            Volmint Technologies <strong>ORBIT</strong> is a futuristic ERP that
            streamlines everyday office operations with advanced technology.
            From employee management to payroll, attendance, communication, and
            real-time insights—manage everything under one secure, user-friendly
            platform with ease and automation.
          </p>
          <div class="flex justify-center mt-10 z-10">
            <button
              class="border border-white text-white px-10 py-4 text-sm font-bold rounded-md hover:bg-indigo-900 hover:text-white transition">
              <i class="fa-solid fa-house fa-bounce me-2"></i>
              VIEW DEMO
            </button>
          </div>
        </div>

        <!-- process image -->
        <div
          #processImage
          class="relative mx-auto z-10 w-[100%] lg:w-[100%] will-change-transform will-change-opacity transition-transform duration-1000 ease-in-out">
          <img
            src="assets/images/redefining-office-management-with-ease-efficiency.webp"
            alt=""
            loading="lazy"
            class="h-auto mx-auto mt-20 rounded-xl hidden sm:block" />
          <img
            src="assets/images/redefining-office-management-with-ease-efficiency-mob-1.webp"
            alt=""
            loading="lazy"
            class="max-h-[500px] mx-auto mt-20 rounded-xl block sm:hidden" />
        </div>

        <!-- circular background (unchanged) -->
        <div
          class="w-[80vw] h-[80vw] max-w-[619px] max-h-[619px] border-2 rounded-full flex justify-center items-center opacity-[0.15] absolute top-[18%] left-[50%] -translate-x-1/2 pointer-events-none border-[#322E4A]"
          style="
            background: linear-gradient(
              45deg,
              rgba(255, 189, 149, 0.09) 0%,
              rgba(62, 34, 141, 0.09) 100%
            );
          ">
          <div
            class="w-[500px] h-[500px] rounded-full flex justify-center items-center -z-10"
            style="background: #01010136; radial-gradient(70.71% 70.71% at 50% 50%, rgba(255, 111, 91, 0.59) 0%, rgba(255, 67, 67, 0) 62%);">
            <div class="bg-red-900 w-[200px] h-[200px] rounded-full"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="max-w-7xl mx-auto my-10 px-3">
    <h2
      class="w-full max-w-5xl mx-auto text-center font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug sm:leading-normal md:leading-[58px] tracking-tight mb-0 lg:my-20 md:font-medium">
      About Orbit – An Advanced Office Management ERP System
    </h2>
    <div class="flex flex-col md:flex-row mt-5 gap-10 md:items-stretch">
      <div
        class="flex-1 rounded-xl relative overflow-hidden mx-auto md:ml-0 w-[80%] sm:w-[60%] md:w-[40%] lg:w-[full] h-auto min-h-[200px] flex-shrink-0"
        style="
          background: linear-gradient(0deg, #dbd0ff, #dbd0ff),
            linear-gradient(180deg, #b7d2ff 0%, #b7d2ff 50%, #bca6ff 100%);
        ">
        <img
          src="assets/images/about-orbit-an-advanced-office-management-erp-system.webp"
          alt="Streamline Admission Processes"
          loading="lazy"
          class="w-full h-full rounded-xl" />
      </div>

      <div class="flex flex-1 flex-col justify-between space-y-3">
        <p
          class="w-full max-w-5xl mx-auto text-center md:text-justify text-gray-600 font-sans text-sm sm:text-base leading-relaxed sm:leading-loose md:leading-[1.8]">
          As a leading IT solutions provider, Volmint Technologies focuses on
          building advanced tools that empower businesses to work smarter and
          grow faster. Therefore, we have built ORBIT – An Office Management ERP
          Software, designed to simplify, streamline, and centralize every
          aspect of office operation. With user-based access, it empowers admins
          to create sub-brands, manage employee data, assign roles, monitor
          activities, and control workflows effortlessly. From payroll,
          attendance, internal communication, and document sharing to analytics,
          real-time tracking, compliance management, and multi-department
          support – ORBIT offers everything under one intuitive dashboard. Its
          automation, scalability, and robust control ensure smarter
          decision-making, seamless collaboration, and long-term operational
          efficiency at every level, while reducing manual errors, improving
          productivity, enhancing transparency, and creating a future-ready
          digital workplace for organizations of every size and industry. Backed
          by continuous innovation, strong data security, and integration
          flexibility, ORBIT helps businesses stay competitive, adapt to
          evolving market demands, and embrace digital transformation with
          confidence and ease.
        </p>
        <p
          class="font-sans font-bold text-sm sm:text-base leading-[6.5vw] sm:leading-[5vw] md:leading-[2.3rem] lg:leading-[37px] tracking-[0.01em] mt-10 sm:mt-0">
          Ratings:
        </p>
        <div class="w-full md:max-w-lg pt-8 md:pt-0">
          <div class="swiper-container-wrapper">
            <swiper-container
              class="mySwiper"
              loop="true"
              autoplay='{"delay": 1, "disableOnInteraction": false,  "pauseOnMouseEnter": false}'
              looped-slides="20"
              speed="3000"
              slides-per-view="auto"
              allow-touch-move="false"
              space-between="16"
              breakpoints='{
            "640": {
              "slidesPerView": 2
            },
            "768": {
              "slidesPerView": 2
            }
          }'>
              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/google-1.webp"
                    alt="Google"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/glassdoor-111x35.webp"
                    alt="Gartner"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/clutch-106x35.webp"
                    alt="Clutch"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/glassdoor-111x35.webp"
                    alt="Glassdoor"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/google-1.webp"
                    alt="Google"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/glassdoor-111x35.webp"
                    alt="Gartner"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/clutch-106x35.webp"
                    alt="Clutch"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/glassdoor-111x35.webp"
                    alt="Glassdoor"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/google-1.webp"
                    alt="Google"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/glassdoor-111x35.webp"
                    alt="Gartner"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/clutch-106x35.webp"
                    alt="Clutch"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/glassdoor-111x35.webp"
                    alt="Glassdoor"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/google-1.webp"
                    alt="Google"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/glassdoor-111x35.webp"
                    alt="Gartner"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/clutch-106x35.webp"
                    alt="Clutch"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>

              <swiper-slide class="!w-auto">
                <div
                  class="flex items-center gap-2 bg-purple-50 rounded-2xl px-3 sm:px-4 md:px-6 py-2">
                  <img
                    src="assets/images/glassdoor-111x35.webp"
                    alt="Glassdoor"
                    loading="lazy"
                    class="h-5 sm:h-6 md:h-8 w-auto object-contain" />
                  <span class="text-gray-900 font-medium text-sm sm:text-base">
                    5.0 star rating
                  </span>
                </div>
              </swiper-slide>
            </swiper-container>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="pb-10 md:pb-20 bg-white">
    <div class="max-w-7xl mx-auto text-center px-3">
      <!-- Heading -->

      <h2
        class="w-full max-w-5xl mx-auto text-center font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug sm:leading-normal md:leading-[58px] tracking-tight mb-5 lg:my-20 md:font-medium">
        Streamline Resource Planning with the Power of ORBIT
      </h2>
      <p class="text-gray-600 mb-12 font-sans sm:text-base">
        ORBIT is developed to optimize and upkeep your workspace and assets
        within, ensuring a highly dynamic portfolio across departments and
        teams. It is an All-in-one tool to improve efficiency and enhance
        collaboration through automation, precision, and secure management.
      </p>

      <!-- Features Grid -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12">
        <!-- Feature Item -->
        <div class="flex flex-col items-center fade-up" vexRevealOnScroll>
          <div
            class="text-indigo-700 bg-pink-50 mb-4 w-8 h-10 sm:w-9 sm:h-11 md:w-10 md:h-12 lg:w-[42px] lg:h-[50px] rounded-full">
            <img
              src="assets/images/desktop (2).gif"
              loading="lazy"
              alt="Desktop" />
          </div>
          <h3 class="font-semibold text-lg md:text-xl mb-2">
            User-Centric Dashboard
          </h3>
          <p class="text-gray-500 text-sm sm:text-base font-sans">
            Intuitive interface that lets teams navigate & manage tasks quickly
            and effortlessly.
          </p>
        </div>

        <div class="flex flex-col items-center fade-up" vexRevealOnScroll>
          <div
            class="text-indigo-700 bg-pink-50 mb-4 w-8 h-10 sm:w-9 sm:h-11 md:w-10 md:h-12 lg:w-[42px] lg:h-[50px] rounded-full">
            <img
              src="assets/images/setting (2).gif"
              loading="lazy"
              alt="Setting" />
          </div>
          <h3 class="font-semibold text-lg md:text-xl mb-2">
            Automated Workflows
          </h3>
          <p class="text-gray-500 text-sm sm:text-base font-sans">
            Save time, effort, and cost with smart automation, ensuring smooth
            and secure operations.
          </p>
        </div>

        <div class="flex flex-col items-center fade-up" vexRevealOnScroll>
          <div
            class="text-indigo-700 bg-pink-50 mb-4 w-8 h-10 sm:w-9 sm:h-11 md:w-10 md:h-12 lg:w-[42px] lg:h-[50px] rounded-full">
            <img
              src="assets/images/history (2).gif"
              loading="lazy"
              alt="History" />
          </div>
          <h3 class="font-semibold text-lg md:text-xl mb-2">
            Real-Time Insights
          </h3>
          <p class="text-gray-500 text-sm sm:text-base font-sans">
            Get instant access to live data, reports, and operational metrics to
            make data-driven decisions.
          </p>
        </div>

        <div class="flex flex-col items-center fade-up" vexRevealOnScroll>
          <div
            class="text-indigo-700 bg-pink-50 mb-4 w-8 h-10 sm:w-9 sm:h-11 md:w-10 md:h-12 lg:w-[42px] lg:h-[50px] rounded-full">
            <img
              src="assets/images/accuracy (2).gif"
              loading="lazy"
              alt="Accuracy" />
          </div>
          <h3 class="font-semibold text-lg md:text-xl mb-2">
            Precision Management
          </h3>
          <p class="text-gray-500 text-sm sm:text-base font-sans">
            Prioritize accuracy with reliable data handling & consistent
            outcomes across all departments.
          </p>
        </div>

        <div class="flex flex-col items-center fade-up" vexRevealOnScroll>
          <div
            class="text-indigo-700 bg-pink-50 mb-4 w-8 h-10 sm:w-9 sm:h-11 md:w-10 md:h-12 lg:w-[42px] lg:h-[50px] rounded-full">
            <img
              src="assets/images/reliability (2).gif"
              loading="lazy"
              alt="Reliability" />
          </div>
          <h3 class="font-semibold text-lg md:text-xl mb-2">
            Robust Performance
          </h3>
          <p class="text-gray-500 text-sm sm:text-base font-sans">
            Dependable system architecture created for uninterrupted office
            operations without downtime.
          </p>
        </div>

        <div class="flex flex-col items-center fade-up" vexRevealOnScroll>
          <div
            class="text-indigo-700 bg-pink-50 mb-4 w-8 h-10 sm:w-9 sm:h-11 md:w-10 md:h-12 lg:w-[42px] lg:h-[50px] rounded-full">
            <img
              src="assets/images/security (2).gif"
              loading="lazy"
              alt="Security" />
          </div>
          <h3 class="font-semibold text-lg md:text-xl mb-2">
            Secure Data Protection
          </h3>
          <p class="text-gray-500 text-sm sm:text-base font-sans">
            Advanced encryption & control access to safeguard sensitive business
            information.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="bg-blue-200 pt-10 pb-20 px-3">
    <div class="mx-auto max-w-7xl text-center">
      <!-- Heading -->
      <h2
        class="w-full max-w-5xl mx-auto text-center font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug sm:leading-normal md:leading-[58px] tracking-tight mb-5 lg:my-20 md:font-medium">
        Key Features of ORBIT – Enterprise Resource Planning System
      </h2>
      <p
        class="text-gray-600 mb-8 text-sm sm:text-base px-2 sm:px-8 md:px-20 font-sans">
        ORBIT ERP System brings all your office operations under one smart
        platform. Whether it is about tracking and managing Sub-Brands,
        employees, management, or higher departments, the system helps to save
        time and enables teams to work efficiently. With ORBIT, achieve business
        goals with automation, accuracy, and collaboration.
      </p>

      <swiper-container
        class="w-full"
        pagination='{"clickable": true}'
        slides-per-group="3"
        breakpoints='{
        "320": {"slidesPerView": 1, "spaceBetween": 16},
        "640": {"slidesPerView": 2, "spaceBetween": 24},
        "1024": {"slidesPerView": 3, "spaceBetween": 32}
      }'>
        <!-- Slide 1 -->
        <swiper-slide
          class="h-full flex flex-col justify-evenly rounded-2xl shadow-lg bg-gradient-to-b from-pink-400 to-pink-400/50 p-4 md:p-6">
          <div class="h-full flex flex-col justify-evenly">
            <h3 class="text-lg md:text-xl font-bold text-white">
              Intuitive Employee Portal
            </h3>
            <p
              class="text-white mt-2 text-sm sm:text-base leading-relaxed font-sans">
              ORBIT provides a single, easy-to-use portal where employees can
              access details, including attendance, tasks, or update information
              at any time, ensuring smoother workflow.
            </p>
            <img
              src="assets/images/intuitive-employee-portal.webp"
              alt="Intuitive Employee Portal"
              loading="lazy"
              class="my-4 rounded-md w-full max-w-xs mx-auto object-contain" />
          </div>
        </swiper-slide>

        <!-- Slide 2 -->
        <swiper-slide
          class="h-full flex flex-col justify-evenly rounded-2xl shadow-lg bg-[#005F96] p-4 md:p-6">
          <div class="h-full flex flex-col justify-evenly">
            <h3 class="text-lg md:text-xl font-bold text-white">
              Secure Document Management
            </h3>
            <p
              class="text-white mt-2 text-sm sm:text-base leading-relaxed font-sans">
              Managing files is now easy with ORBIT! Store, share, and access
              documents instantly with advanced encryption to reduce dependency
              and work delays.
            </p>
            <img
              src="assets/images/secure-document-management.webp"
              alt="Secure Document Management"
              loading="lazy"
              class="my-4 rounded-md w-full max-w-xs mx-auto object-contain" />
          </div>
        </swiper-slide>

        <!-- Slide 3 -->
        <swiper-slide
          class="h-full flex flex-col justify-evenly rounded-2xl shadow-lg bg-[#01914B] p-4 md:p-6">
          <div class="h-full flex flex-col justify-evenly">
            <h3 class="text-lg md:text-xl font-bold text-white">
              Real-Time Reports & Analytics
            </h3>
            <p
              class="text-white mt-2 text-sm sm:text-base leading-relaxed font-sans">
              The system allows users to track, manage, and make informed
              decisions through detailed insights, ensuring accurate reports and
              analytics.
            </p>
            <img
              src="assets/images/real-time-reports-analytics.webp"
              alt="Real-Time Reports & Analytics"
              loading="lazy"
              class="my-4 rounded-md w-full max-w-xs mx-auto object-contain" />
          </div>
        </swiper-slide>
        <swiper-slide
          class="h-full flex flex-col justify-evenly rounded-2xl shadow-lg bg-[#AF0063] p-4 md:p-6">
          <div class="h-full flex flex-col justify-evenly">
            <h3 class="text-lg md:text-xl font-bold text-white">
              Payroll & Finance Management
            </h3>
            <p
              class="text-white mt-2 text-sm sm:text-base leading-relaxed font-sans">
              ORBIT automates repetitive tasks, calculates salaries, tracks
              deductions, manages allowances, and ensures timely payments
              without errors.
            </p>
            <img
              src="assets/images/payroll-finance-management.webp"
              alt="Payroll & Finance Management"
              loading="lazy"
              class="my-4 rounded-md w-full max-w-xs mx-auto object-contain" />
          </div>
        </swiper-slide>

        <!-- Slide 5 -->
        <swiper-slide
          class="h-full flex flex-col justify-evenly rounded-2xl shadow-lg bg-[#9000CE] p-4 md:p-6">
          <div class="h-full flex flex-col justify-evenly">
            <h3 class="text-lg md:text-xl font-bold text-white">
              User-Based Access & Control
            </h3>
            <p
              class="text-white mt-2 text-sm sm:text-base leading-relaxed font-sans">
              It offers user-based access & control, ensuring data privacy and
              security, avoiding unnecessary clutter for each individual user.
            </p>
            <img
              src="assets/images/user-based-access-control.webp"
              alt="User-Based Access & Control"
              loading="lazy"
              class="my-4 rounded-md w-full max-w-xs mx-auto object-contain" />
          </div>
        </swiper-slide>
        <swiper-slide
          class="h-full flex flex-col justify-evenly rounded-2xl shadow-lg bg-[#009384] p-4 md:p-6">
          <div class="h-full flex flex-col justify-evenly">
            <h3 class="text-lg md:text-xl font-bold text-white">
              Multi-Department Management
            </h3>
            <p
              class="text-white mt-2 text-sm sm:text-base leading-relaxed font-sans">
              Instead of using separate tools for HR, Finance, Operations, and
              other departments, Orbit brings everything under one platform.
            </p>
            <img
              src="assets/images/multi-department-management.webp"
              alt="Multi-Department Management"
              loading="lazy"
              class="my-4 rounded-md w-full max-w-xs mx-auto object-contain" />
          </div>
        </swiper-slide>

        <swiper-slide
          class="h-full flex flex-col justify-evenly rounded-2xl shadow-lg bg-fuchsia-500 p-4 md:p-6">
          <div class="h-full flex flex-col justify-evenly">
            <h3 class="text-lg md:text-xl font-bold text-white">
              Holiday & Leave Tracking
            </h3>
            <p
              class="text-white mt-2 text-sm sm:text-base leading-relaxed font-sans">
              Employees can apply for leave directly, managers can approve or
              decline requests instantly, and the system keeps attendance
              records updated.
            </p>
            <img
              src="assets/images/holiday-leave-tracking.webp"
              alt="Add Multiple Institutions"
              loading="lazy"
              class="my-4 rounded-md w-full max-w-xs mx-auto object-contain" />
          </div>
        </swiper-slide>

        <swiper-slide
          class="h-full flex flex-col justify-evenly rounded-2xl shadow-lg bg-accent-500 p-4 md:p-6">
          <div class="h-full flex flex-col justify-evenly">
            <h3 class="text-lg md:text-xl font-bold text-white">
              Device Management
            </h3>
            <p
              class="text-white mt-2 text-sm sm:text-base leading-relaxed font-sans">
              For companies that provide laptops, desktops, or other devices to
              employees, Orbit offers built-in device tracking and management.
            </p>
            <img
              src="assets/images/device-management.webp"
              alt="Device Management"
              loading="lazy"
              class="my-4 rounded-md w-full max-w-xs mx-auto object-contain" />
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
  </section>
  <section class="pt-10 bg-white">
    <div
      class="max-w-7xl mx-auto px-3 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-12 items-center">
      <!-- Left Content -->
      <div>
        <h2
          class="w-full max-w-5xl mx-auto text-center lg:text-left font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug sm:leading-normal md:leading-[58px] tracking-tight mb-0 lg:my-20 md:font-medium">
          Streamline Your Office Operations<br />
          with ORBIT Office ERP
        </h2>
        <p
          class="font-sans text-center md:text-justify text-sm sm:text-base leading-[28px] sm:leading-[32px] md:leading-[34px] lg:leading-[37px] tracking-wide text-gray-600 mb-12">
          ORBIT isn’t just another office management tool—it’s a complete
          operating system for your business. It brings all your operations,
          employees, and activities together on one smart, connected platform.
          From daily operations to team collaboration, everything runs in sync,
          making work more efficient, customizable, and seamless. With ORBIT,
          your office doesn’t just manage tasks—it works smarter, faster, and
          more effectively.
        </p>
        <button
          class="border border-indigo-900 text-indigo-900 px-10 py-4 text-sm font-bold rounded-md hover:bg-indigo-900 hover:text-white transition block mx-auto md:mx-0">
          BOOK DEMO
        </button>
      </div>

      <!-- Right Image -->
      <div class="flex justify-center">
        <video
          preload="metadata"
          src="assets/images/automate-selection (1) (1).webm"
          class="rounded-2xl shadow-lg w-full max-w-lg"
          autoplay
          loop
          [muted]="true"
          playsinline></video>
      </div>
    </div>
  </section>
  <section class="max-w-7xl mx-auto text-center pt-10 md:pt-0 px-3 space-y-6">
    <h2
      class="w-full max-w-5xl mx-auto text-center font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug sm:leading-normal md:leading-[58px] tracking-tight mt-4 mb-12 lg:my-20 md:font-medium">
      Why Do You Need ORBIT Office ERP
    </h2>
    <!-- Feature boxes -->
    <div class="flex flex-col md:flex-row gap-5 text-left mt-10">
      <div
        class="rounded-md p-3 cursor-pointer transition-all duration-300"
        [ngClass]="{
          'bg-[#BCE7FF]': selectedGif === 0,
          'bg-blue-200': selectedGif !== 0
        }"
        (click)="showGif(0)">
        <h3
          class="font-bold font-sans"
          [ngClass]="{
            'text-[#339BFB]': selectedGif === 0,
            'bg-blue-200': selectedGif !== 0
          }">
          Automate Workflow
        </h3>
        <p class="font-sans text-sm sm:text-base">
          Automating day-to-day workflows such as approvals, reporting, and
          scheduling.
        </p>
      </div>
      <div
        class="rounded-md p-3 cursor-pointer transition-all duration-300"
        [ngClass]="{
          'bg-[#BCE7FF]': selectedGif === 1,
          'bg-blue-200': selectedGif !== 1
        }"
        (click)="showGif(1)">
        <h3
          class="font-bold font-sans"
          [ngClass]="{
            'text-[#339BFB]': selectedGif === 1,
            'bg-blue-200': selectedGif !== 1
          }">
          Centralized Operations
        </h3>
        <p class="font-sans text-sm sm:text-base">
          A single centralized system to manage HR, finance, inventory,
          communication, and more.
        </p>
      </div>
      <div
        class="rounded-md p-3 cursor-pointer transition-all duration-300"
        [ngClass]="{
          'bg-[#BCE7FF]': selectedGif === 2,
          'bg-blue-200': selectedGif !== 2
        }"
        (click)="showGif(2)">
        <h3
          class="font-bold font-sans"
          [ngClass]="{
            'text-[#339BFB]': selectedGif === 2,
            'bg-blue-200': selectedGif !== 2
          }">
          Smart Notification
        </h3>
        <p class="font-sans text-sm sm:text-base">
          Role-based notifications for approvals, reminders, deadlines, and
          updates.
        </p>
      </div>
      <div
        class="rounded-md p-3 cursor-pointer transition-all duration-300"
        [ngClass]="{
          'bg-[#BCE7FF]': selectedGif === 3,
          'bg-blue-200': selectedGif !== 3
        }"
        (click)="showGif(3)">
        <h3
          class="font-bold font-sans"
          [ngClass]="{
            'text-[#339BFB]': selectedGif === 3,
            'bg-blue-200': selectedGif !== 3
          }">
          Data Security
        </h3>
        <p class="font-sans text-sm sm:text-base">
          Multi-layer access control and compliance with industry security
          standards.
        </p>
      </div>
      <div
        class="rounded-md p-3 cursor-pointer transition-all duration-300"
        [ngClass]="{
          'bg-[#BCE7FF]': selectedGif === 4,
          'bg-blue-200': selectedGif !== 4
        }"
        (click)="showGif(4)">
        <h3
          class="font-bold font-sans"
          [ngClass]="{
            'text-[#339BFB]': selectedGif === 4,
            'bg-blue-200': selectedGif !== 4
          }">
          Analytics & Reports
        </h3>
        <p class="font-sans text-sm sm:text-base">
          Detailed analytics and reports that provide insights into performance
          and resource utilization.
        </p>
      </div>
    </div>
    <!-- GIF container -->
    <div class="mt-6 relative">
      <ng-container *ngFor="let gif of gifs; let i = index">
        <!-- For .webm / video files -->
        <video
          *ngIf="gif.endsWith('.webm') || gif.endsWith('.mp4')"
          [src]="gif"
          preload="metadata"
          [class.hidden]="selectedGif !== i"
          class="w-full max-h-[600px] rounded-md mx-auto"
          autoplay
          loop
          [muted]="true"
          playsinline></video>
      </ng-container>
    </div>
  </section>
  <section class="max-w-7xl px-3 mx-auto my-10 text-center">
    <h2
      class="w-full max-w-5xl mx-auto text-center font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug sm:leading-normal md:leading-[58px] tracking-tight mb-12 mt-12 lg:my-20 md:font-medium">
      What Makes ORBIT Office ERP Stand Out
    </h2>
    <div class="relative my-10 space-y-5">
      <!-- Card 1 -->
      <div
        class="sticky top-24 mx-auto rounded-xl shadow-xl flex items-center justify-center text-white text-base sm:text-lg md:text-2xl lg:text-3xl font-bold bg-cover bg-center bg-no-repeat"
        style="
          background-image: linear-gradient(
              90deg,
              rgba(186, 109, 0, 0.85) 44.61%,
              rgba(84, 49, 0, 0.85) 100%
            ),
            url(&quot;assets/images/application-management.webp&quot;);
        ">
        <div
          class="h-full relative rounded-xl overflow-hidden flex flex-col md:flex-row items-center bg-cover bg-center bg-no-repeat w-full">
          <!-- Overlay content wrapper -->
          <div class="p-6 sm:p-10 md:p-14 text-white max-w-xl">
            <h3
              class="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 font-sans">
              Unified Business Platform
            </h3>
            <p class="text-sm sm:text-base leading-relaxed mb-6 font-sans">
              ORBIT is a unified system that brings all the office operations –
              HR, Finance, Marketing, IT, Business Development – onto a single
              platform. It helps to reduce errors, automates tasks, and
              eliminates the hassle of switching between multiple tools,
              ensuring a smooth, connected workflow across departments, saving
              time and boosting efficiency.
            </p>
          </div>

          <!-- Optional right-side image / illustration -->
          <div class="flex justify-center p-6">
            <video
              preload="metadata"
              src="assets/images/manage-counselors.webm"
              class="rounded-xl object-contain"
              alt="Application Management"
              autoplay
              loop
              [muted]="true"
              playsinline></video>
          </div>
        </div>
      </div>

      <!-- Card 2 -->
      <div
        class="sticky top-28 mx-auto rounded-xl shadow-xl flex items-center justify-center text-white text-base sm:text-lg md:text-2xl lg:text-3xl font-bold bg-cover bg-center bg-no-repeat"
        style="
          background-image: linear-gradient(
              rgba(0, 146, 75, 0.8),
              rgba(0, 146, 75, 0.8)
            ),
            url(&quot;assets/images/stand-out-2nd-bg.webp&quot;);
        ">
        <div
          class="relative h-full rounded-xl overflow-hidden flex flex-col md:flex-row items-center bg-cover bg-center bg-no-repeat w-full">
          <!-- Overlay content wrapper -->
          <div class="p-6 sm:p-10 md:p-14 text-white max-w-xl">
            <h3
              class="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 font-sans">
              Customization for Every Business
            </h3>
            <p class="text-sm sm:text-base leading-relaxed mb-6 font-sans">
              We just don’t provide a rigid ERP system, unlike others. We
              analyze your business needs and build modules that adapt to your
              organizational requirements. Whether you’re managing a small team
              or a large enterprise, it offers customizable modules that fit
              unique workflows, ensuring maximum relevance and usability for
              every department.
            </p>
          </div>

          <!-- Optional right-side image / illustration -->
          <div class="flex justify-center p-6">
            <video
              preload="metadata"
              src="assets/images/manage-counselors.webm"
              class="rounded-xl object-contain"
              alt="Application Management"
              autoplay
              loop
              [muted]="true"
              playsinline></video>
          </div>
        </div>
      </div>

      <!-- Card 3 -->
      <div
        class="sticky top-32 mx-auto rounded-xl shadow-xl flex items-center justify-center text-white text-base sm:text-lg md:text-2xl lg:text-3xl font-bold bg-cover bg-center bg-no-repeat"
        style="
          background-image: linear-gradient(
              rgba(0, 95, 150, 0.8),
              rgba(0, 95, 150, 0.8)
            ),
            url(&quot;assets/images/stand-out-3rd-bg.webp&quot;);
        ">
        <div
          class="relative h-full rounded-xl overflow-hidden flex flex-col md:flex-row items-center bg-cover bg-center bg-no-repeat w-full">
          <!-- Overlay content wrapper -->
          <div class="p-6 sm:p-10 md:p-14 text-white max-w-xl">
            <h3
              class="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 font-sans">
              Real-Time Decision Support
            </h3>
            <p class="text-sm sm:text-base leading-relaxed mb-6 font-sans">
              ORBIT offers an intuitive dashboard that provides real-time
              reports and analytics to cater to individuals' requirements -be it
              admin, staff, or employee. Live insights offered by the system
              help leaders track performance and resources instantly, empowering
              businesses to respond to challenges quickly and stay ahead in a
              competitive market.
            </p>
          </div>

          <!-- Optional right-side image / illustration -->
          <div class="flex justify-center p-6">
            <video
              preload="metadata"
              src="assets/images/manage-counselors.webm"
              class="rounded-xl object-contain"
              alt="Application Management"
              autoplay
              loop
              [muted]="true"
              playsinline></video>
          </div>
        </div>
      </div>

      <!-- Card 4 -->
      <div
        class="sticky top-36 mx-auto rounded-xl shadow-xl flex items-center justify-center text-white text-base sm:text-lg md:text-2xl lg:text-3xl font-bold bg-cover bg-center bg-no-repeat"
        style="
          background-image: linear-gradient(
              rgba(188, 41, 124, 0.8),
              rgba(188, 41, 124, 0.8)
            ),
            url(&quot;assets/images/stand-out-4th-bg.webp&quot;);
        ">
        <div
          class="relative h-full rounded-xl overflow-hidden flex flex-col md:flex-row items-center bg-cover bg-center bg-no-repeat w-full">
          <!-- Overlay content wrapper -->
          <div class="p-6 sm:p-10 md:p-14 text-white max-w-xl">
            <h3
              class="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 font-sans">
              Strong Security Framework
            </h3>
            <p class="text-sm sm:text-base leading-relaxed mb-6 font-sans">
              Being one of the preferred IT firms, we understand the importance
              of data safety. Therefore, Volmint has designed ORBIT with
              advanced data security in mind. From encryption to role-based
              access controls, the system ensures sensitive business information
              is fully protected, giving you confidence and peace of mind while
              managing critical operations.
            </p>
          </div>

          <!-- Optional right-side image / illustration -->
          <div class="flex justify-center p-6">
            <video
              preload="metadata"
              src="assets/images/manage-counselors.webm"
              class="rounded-xl object-contain"
              alt="Application Management"
              autoplay
              loop
              [muted]="true"
              playsinline></video>
          </div>
        </div>
      </div>

      <!-- Card 5 -->
      <div
        class="sticky top-40 mx-auto rounded-xl shadow-xl flex items-center justify-center text-white text-base sm:text-lg md:text-2xl lg:text-3xl font-bold bg-cover bg-center bg-no-repeat"
        style="
          background-image: linear-gradient(
              rgba(162, 43, 213, 0.8),
              rgba(162, 43, 213, 0.8)
            ),
            url(&quot;assets/images/stand-out-5th-bg.webp&quot;);
        ">
        <div
          class="relative h-full rounded-xl overflow-hidden flex flex-col md:flex-row items-center bg-cover bg-center bg-no-repeat w-full">
          <!-- Overlay content wrapper -->
          <div class="p-6 sm:p-10 md:p-14 text-white max-w-xl">
            <h3
              class="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 font-sans">
              Enhanced Collaboration & Productivity
            </h3>
            <p class="text-sm sm:text-base leading-relaxed mb-6 font-sans">
              Collaboration and engagement among the teams/departments are a
              must to run an organization smoothly. ORBIT promotes teamwork by
              connecting employees, managers, and administrators in a single
              environment through smart notifications, task tracking, and shared
              access tools that help teams collaborate more effectively,
              minimize delays, and foster transparency.
            </p>
          </div>

          <!-- Optional right-side image / illustration -->
          <div class="flex justify-center p-6">
            <video
              preload="metadata"
              src="assets/images/manage-counselors.webm"
              class="rounded-xl object-contain"
              alt="Application Management"
              autoplay
              loop
              [muted]="true"
              playsinline></video>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="max-w-7xl mx-auto mt-10 mb-20 text-center space-y-7 px-3">
    <h2
      class="w-full max-w-5xl mx-auto text-center font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug sm:leading-normal md:leading-[58px] tracking-tight md:font-medium lg:my-20">
      FAQs
    </h2>

    <div *ngFor="let faq of faqs" class="mb-4 rounded-xl shadow">
      <!-- Question -->
      <div
        class="flex justify-between items-center p-4 cursor-pointer select-none transition-colors duration-300"
        [ngClass]="faq.open ? 'bg-blue-100' : 'bg-white hover:bg-gray-50'"
        (click)="toggleFaq(faq.id)">
        <div class="flex items-center gap-3">
          <span class="font-bold text-sm sm:text-base text-blue-900">
            {{ faq.id | number: "2.0" }}
          </span>
          <h3
            class="text-lg sm:text-xl md:text-2xl lg:text-[23px] text-gray-900 align-middle font-sans">
            {{ faq.question }}
          </h3>
        </div>
        <div
          class="flex items-center justify-center w-8 h-8 rounded-full transition-transform duration-500 ease-in-out"
          [ngClass]="
            faq.open
              ? 'bg-blue-900 text-white rotate-45'
              : 'bg-blue-100 text-blue-900'
          ">
          +
        </div>
      </div>

      <!-- Answer wrapper (outer: transition, measured by TS) -->
      <div
        #answerRef
        class="overflow-hidden text-left transition-all duration-500 ease-in-out"
        [style.max-height]="faq.open ? faq.height + 'px' : '0px'"
        [style.opacity]="faq.open ? '1' : '0'"
        [ngClass]="faq.open ? 'bg-blue-100' : 'bg-white hover:bg-gray-50'">
        <!-- inner content: fixed padding so scrollHeight is accurate -->
        <div class="answer-inner p-4">
          <p
            class="text-gray-700 text-sm sm:text-base leading-relaxed font-sans">
            {{ faq.answer }}
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    class="relative px-3 w-full bg-cover bg-center bg-no-repeat text-white"
    style="
      background-image: url(&quot;assets/images/blue-gradient-image.webp&quot;);
    ">
    <!-- Overlay for better text readability -->
    <div class="absolute inset-0 bg-black/5"></div>

    <!-- Content -->
    <div
      class="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-28 text-center space-y-6">
      <!-- Top small heading -->
      <h3
        class="text-sm sm:text-base font-medium tracking-wide uppercase font-sans">
        Looking for smarter ways to manage your office operations?
      </h3>

      <!-- Main heading -->
      <h2
        class="w-full max-w-5xl mx-auto text-center font-['Plus_Jakarta_Sans'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-snug sm:leading-normal md:leading-[58px] tracking-tight md:font-medium lg:my-20">
        Discover how ORBIT Office ERP can simplify complex workflows,<br
          class="hidden sm:block" />
        improve efficiency, and accelerate growth for your business.
      </h2>

      <!-- Subheading -->
      <p
        class="text-sm sm:text-base text-gray-200 leading-relaxed max-w-2xl mx-auto font-sans">
        Request For A Demo Here
      </p>

      <!-- Button -->
      <div>
        <button
          class="border border-indigo-900 text-white px-10 py-4 text-sm font-bold rounded-md hover:bg-indigo-900 hover:text-white transition">
          CONTACT US
        </button>
      </div>
    </div>
  </section>
  <app-footer></app-footer>
</div>
